export const UPPY_TUS_ENDPOINT = '/api/file/asset/upload/tus/1.0.0';
